import { render, staticRenderFns } from "./DashboardDriverConsumptionBreakdown.vue?vue&type=template&id=8b367de4&scoped=true"
import script from "./DashboardDriverConsumptionBreakdown.vue?vue&type=script&lang=js"
export * from "./DashboardDriverConsumptionBreakdown.vue?vue&type=script&lang=js"
import style0 from "./DashboardDriverConsumptionBreakdown.vue?vue&type=style&index=0&id=8b367de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b367de4",
  null
  
)

export default component.exports